var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "4" } },
        [
          _c("FormulateInput", {
            staticClass: "required",
            attrs: {
              id: "tax-parameter-ncm",
              name: "tax-parameter-ncm",
              type: "select-searchable",
              label: _vm.$t("NCM"),
              placeholder: _vm.$t("Digite para pesquisar"),
              options: _vm.getComboNcms,
              validation: "required",
              disabled: _vm.isEdit,
            },
            on: { fetchSearch: _vm.ncmSearch },
            model: {
              value: _vm.fiscalTaxParameter.ncm,
              callback: function ($$v) {
                _vm.$set(_vm.fiscalTaxParameter, "ncm", $$v)
              },
              expression: "fiscalTaxParameter.ncm",
            },
          }),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { md: "3" } },
        [
          _c("FormulateInput", {
            staticClass: "required",
            attrs: {
              id: "tax-parameter-st-cbs-ibs",
              name: "tax-parameter-st-cbs-ibs",
              type: "vue-select",
              options: _vm.comboCstCbsIbs,
              placeholder: _vm.$t("Selecione"),
              validation: "required",
              label: _vm.$t("Situação Trib. CBS/IBS"),
            },
            model: {
              value: _vm.fiscalTaxParameter.stCbsIbsCode,
              callback: function ($$v) {
                _vm.$set(_vm.fiscalTaxParameter, "stCbsIbsCode", $$v)
              },
              expression: "fiscalTaxParameter.stCbsIbsCode",
            },
          }),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { md: "5" } },
        [
          _c("FormulateInput", {
            staticClass: "required",
            attrs: {
              id: "tax-parameter-fiscal-classification-cbs-ibs",
              name: "tax-parameter-fiscal-classification-cbs-ibs",
              type: "vue-select",
              placeholder: _vm.$t("Selecione"),
              validation: "required",
              disabled: !_vm.fiscalTaxParameter.stCbsIbsCode,
              options: _vm.comboFiscalClassificationCbsIbs,
              label: _vm.$t("Classificação CBS/IBS"),
            },
            model: {
              value: _vm.fiscalTaxParameter.fiscalClassificationCbsIbsCode,
              callback: function ($$v) {
                _vm.$set(
                  _vm.fiscalTaxParameter,
                  "fiscalClassificationCbsIbsCode",
                  $$v
                )
              },
              expression: "fiscalTaxParameter.fiscalClassificationCbsIbsCode",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }